/* eslint-disable no-console */
import React from 'react';
import { Button } from 'react-bootstrap';
import { Common } from 'ws-scripts/modules/common';
import PropTypes from 'prop-types';
import { SAMP_PAYMENT } from '../../../constants/labels';
import PaymentCalculatorController from '../../../containers/PaymentCalculatorController';

import './PaymentCalculator.scss';

let isComposer = false;
class PaymentSummary extends React.Component {
	constructor(props) {
		super(props);

		this.state = { isComposer: false };
		this.handleOpen = name => {
			this.props.showModal(name, { message: `This is a ${name} modal` });
		};
	}

	componentDidMount() {
		isComposer = !!(window && window.top && window.top.composer);
		// eslint-disable-next-line react/no-did-mount-set-state
		this.setState({ isComposer });
	}

	render() {
		let rootComponent = null;
		const {
			apr,
			downPayment,
			selectedAprTerm,
			monthlyPayment
		} = this.props;

		rootComponent = (
			<Common
				render={({ labels, prefs }) => {
					// console.log(JSON.stringify(prefs, null, 2));
					const calcText =
						prefs.calcPaymentText !== ''
							? prefs.calcPaymentText
							: labels.get('CALCULATE_PAYMENT');
					const prefsBtnClasses =
						prefs.buttonClasses !== ''
							? ` ${prefs.buttonClasses}`
							: '';
					const btnClasses = `btn btn-primary btn-block payment-summary-calculate${prefsBtnClasses}`;
					return (
						<div className="payment-summary">
							<form>
								<div className="payment-summary-sample clearfix">
									{/* eslint-disable-next-line jsx-a11y/label-has-for */}
									<label
										htmlFor="sample-payment-value"
										className="pull-left"
									>
										{SAMP_PAYMENT}
										<sup>2</sup>:
									</label>
									<div
										id="sample-payment-value"
										className="pull-right payment-summary-dollar"
									>
										<strong>{monthlyPayment}</strong>
										<span>/mo</span>
									</div>
								</div>
								<p className="payment-summary-support-text">
									{selectedAprTerm} Months @ {apr}% A.P.R.
									(estimated financing rate) ({downPayment}{' '}
									Down Payment)
								</p>
								<div className="payment-summary-cta">
									<Button
										className={btnClasses}
										onClick={() => {
											this.handleOpen('dynamic');
										}}
									>
										{calcText}
										<sup>{prefs.superScriptText}</sup>
									</Button>
								</div>

								{this.state.isComposer && (
									<div className="payment-calculator-composer">
										<PaymentCalculatorController />
									</div>
								)}
							</form>
						</div>
					);
				}}
			/>
		);
		return rootComponent;
	}
}

PaymentSummary.propTypes = {
	showModal: PropTypes.func.isRequired,
	apr: PropTypes.number.isRequired,
	downPayment: PropTypes.string.isRequired,
	selectedAprTerm: PropTypes.number.isRequired,
	monthlyPayment: PropTypes.string.isRequired
};

export default PaymentSummary;



// WEBPACK FOOTER //
// ./src/components/views/loaded/PaymentSummary.jsx